// https://beike.pipacoding.com/?staffId=19642&teacherId=30006810&unitId=37045&t=1658461709&chapterId=781678
const getProtocal = function (){
    return 'https://';
};
const getApiHostOrProxy = function (){
    return 'api.hetao101.com';
};
const getApiTestingString = () => {
    const str = '';
    if (window.getInComingStudyInfo().appEnv && window.getInComingStudyInfo().appEnv.includes('testing')) {
        return window.getInComingStudyInfo().appEnv;
    }
    return str;

};

const getChapters = ({
    unitId,
    subjectId = 1 /* scratch就是1*/
}) => {
    const testingOrNo = getApiTestingString() ? `${getApiTestingString()}.` : '';
    const url = `https://crm.${testingOrNo}pipacoding.com/crm-teaching-preparation/v1/class-course/chapter?unitId=${unitId}&subjectId=${subjectId}`;
    return fetch(url);
};
const postLearningDetail = ({
    itemId,
    itemType,
    learningStatus = 1,
    learningTime,
    staffId,
    teacherId,
    unitId,
    videoTime
}) => {
    const testingOrNo = getApiTestingString() ? `${getApiTestingString()}.` : '';
    const url = `${getProtocal()}crm.${testingOrNo}pipacoding.com/crm-teaching-preparation/v1/learning-situation`;

    const body = {
        itemId,
        itemType,
        learningStatus,
        learningTime,
        staffId,
        teacherId,
        unitId
    };
    if (videoTime) {
        body.videoTime = videoTime * 1000;
    }
    return fetch(url, {
        method: 'POST',
        headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
        body: JSON.stringify(body)
    }).then(response => response.json())
        .then(json => {
            // eslint-disable-next-line no-console
            console.log('报告学习情况结果', json);
        });
};


export {
    getProtocal,
    getApiHostOrProxy,
    getChapters,
    postLearningDetail
};
